import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
const volumeNames = ['Beginner Barre', 'Glutes, Thighs & Lower Body', 'Core, Balance & Stability', 'Arms, Upper Body & Posture', 'Cardio & Full-Body Barre', 'Progressive Barre Class Series'];
const separateAreas = ['Beginner Barre classes.', 'Glute and thigh sequences.', 'Core and balance work.', 'Upper-body programming.', 'Cardio Barre.', 'Progressive classes.', 'Modifications.', 'Corrections.', 'Coaching cues.', 'Class structures.'];
export function SystemOverview() {
  return <section className="bg-background px-4 py-20 sm:py-28" data-id="element-329" data-mp="13wfx9gtp21s4">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-330" data-mp="13ttgcqkwy9x8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-331" data-mp="yz61zkjmivwd">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-332" data-mp="236e4esdv03nl">
            Your complete 6-in-1 system
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-foreground sm:text-4xl" data-id="element-333" data-mp="2845vxlaldnr9">
            Why Search for Six Different Barre Resources When Everything Can
            Be Organized Inside{' '}
            <span className="italic text-primary" data-id="element-334" data-mp="2i34w0fhakb2n">One Complete System?</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-335" data-mp="1kh7fuoqdwhtv" />
          <ol className="mt-8 divide-y divide-accent/25 border-y border-accent/25" data-id="element-336" data-mp="1pezbntu5go3c">
            {volumeNames.map((name, index) => <li key={name} className="flex items-baseline gap-4 py-3.5" data-id="element-337" data-mp="1ud12j0xthrpd" data-mpi={index}>
                <span className="w-6 shrink-0 font-display text-2xl font-semibold text-primary" data-id="element-338" data-mp="1z5aq4abgmfoh">
                  {index + 1}
                </span>
                <span className="flex flex-1 flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5" data-id="element-339" data-mp="11p4xn8y3gthi">
                  <span className="text-base font-medium text-foreground" data-id="element-340" data-mp="16mdgzcuzb3kc">
                    {name}
                  </span>
                  <span className="text-sm text-muted-foreground" data-id="element-341" data-mp="top9p4pez4zr">
                    25 Ready-to-Teach Classes
                  </span>
                </span>
              </li>)}
          </ol>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.08em] text-primary" data-id="element-342" data-mp="13esb9talpr9p">
            6 Volumes. 150 Classes. One Complete Barre Teaching System.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="self-start rounded-2xl border border-accent/30 bg-surface p-6 shadow-card sm:p-9" data-id="element-343" data-mp="aq37fmi5v7u9">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-344" data-mp="210xwipre3lj4">
            Instead of searching separately for:
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-345" data-mp="23mp0h2l37n4x">
            {separateAreas.map(item => <li key={item} className="rounded-full border border-primary/20 bg-surface-subtle px-3 py-1.5 text-xs font-medium text-foreground" data-id="element-346" data-mp="28ls027iat15i">
                {item}
              </li>)}
          </ul>
          <p className="mt-8 border-t border-accent/25 pt-6 font-display text-xl font-medium leading-8 text-foreground" data-id="element-347" data-mp="1ynvvjyjv94gd">
            You get everything organized inside{' '}
            <span className="italic text-primary" data-id="element-348" data-mp="2rb87zfwbbvvy">one professional 6-in-1 instructor system.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}